import { Entity } from '@hglobal/common';

import { UserProfile } from './user.model';

export enum CommentReadStatus {
  Unread = 'unread',
  Read = 'readNotAnswered',
  Answered = 'readAnswered',
}

export interface UserFinancialRequest {
  category?: string;
  requestId: number;
  requestType: string;
  requestIdHash: string;
  date: Date;
  status: FinancialRequestStatus;
  assignee?: UserProfile;
}

export interface AdminFinancialRequest extends Entity {
  createdAt: Date;
  location: string;
  status: FinancialRequestStatus;
  category?: string;
  userStaffKey: string;
  userTelegramUsername: string;
  readStatus: CommentReadStatus;
  user: UserProfile;
  assignee?: UserProfile;
}

export interface AdminFinancialRequestAssigneeCategory {
  assigneeUserId?: number;
  categoryId?: number;
}

export enum FinancialRequestStatus {
  New = 'new',
  InProgress = 'inProgress',
  Rejected = 'rejected',
  Completed = 'completed',
  Canceled = 'canceled',
}

export enum FinancialRequestHistoryItemType {
  Status = 'status',
  Assignee = 'assignee',
  Category = 'category',
}

export interface FinancialRequestDetailsHistory {
  status: FinancialRequestStatus;
  createdAt: Date;
  historyInfo: string;
  eventType: FinancialRequestHistoryItemType;
}

export interface FinancialRequestDetailsEncryptedComments {
  requestIdHash?: string;
  data: {
    file?: string;
    createdAt?: Date;
    message: string;
    fromUser?: string;
    status: string;
  };
  files?: string[];
}

export interface UserFinancialRequestDetails extends UserFinancialRequest {
  files: string[];
  history: FinancialRequestDetailsHistory[];
  comments?: FinancialRequestDetailsEncryptedComments[];
}

export interface AdminFinancialRequestDetails extends AdminFinancialRequest {
  userSlackId: string;
  requestIdHash: string;
  files: string[];
  history: FinancialRequestDetailsHistory[];
  comments?: FinancialRequestDetailsEncryptedComments[];
}

export interface FinancialCategory extends Entity {
  name: string;
  description: string;
}

export interface Accountant {
  id?: number;
  userId?: number;
  fullName?: string;
  location?: string;
  assigneeType: string;
  active: boolean;
  assignedRequests?: number;
  completedRequests?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface AccountantSelectOptions {
  id: number;
  name: string;
}
